export const ShippingCarriers = {
  USPS: 'USPS',
  FedEx: 'FedEx',
};
